import { IconButton, Tooltip } from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../components/Programa/Programa'
import Table from '../../components/Table'
import { metodoPrograma } from '../../components/api'
import Edicao from './Edicao'
import ListaUsuario from './ListaUsuario'

const Usuario = () => {
  const [lista, setLista] = useState([])
  const [idTipoUsuario, setIdTipoUsuario] = useState(-1)

  const buscaLista = useCallback(async () => {
    const res = await metodoPrograma('listaContratante', {
      CnstPagnation: [1000, 1, '', []],
    })
    setLista(res.lista || [])
  }, [])

  useEffect(() => {
    buscaLista()
  }, [buscaLista])

  const [tela, setTela] = useState('lista')
  const [contratante, setContratante] = useState({})
  const [ferramentas, setFerramentas] = useState()
  const [usuarioAberto, setUsuarioAberto] = useState([])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas()
        break
      case 'usuarios':
        setFerramentas(
          <Tooltip title="Adicionar Usuário">
            <IconButton onClick={() => setTela('edicao')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'edicao':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela])

  const voltar = () => {
    setTela('lista')
    setContratante(undefined)
    setUsuarioAberto(undefined)
  }

  const handleClick = (_, linha) => {
    setContratante(linha)
    setTela('usuarios')
  }
  return (
    <Programa codigo="Usuario" ferramentas={ferramentas}>
      {tela === 'lista' && (
        <Table
          dados={lista}
          head={['ID', 'Nome', 'Inclusão', 'Exclusão']}
          line={(l) => [l[0], l[1], l[2], l[3]]}
          onClick={handleClick}
        />
      )}
      {tela === 'usuarios' && (
        <ListaUsuario
          {...{
            contratante,
            setUsuarioAberto,
            setTela,
            voltar,
            idTipoUsuario,
            setIdTipoUsuario,
          }}
        />
      )}
      {tela === 'edicao' && (
        <Edicao {...{ contratante, idTipoUsuario, usuarioAberto, voltar }} />
      )}
    </Programa>
  )
}

export default memo(Usuario, isEqual)
